webpackJsonp([144251824217401],{

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LeftPicture = __webpack_require__(71);
	
	var _LeftPicture2 = _interopRequireDefault(_LeftPicture);
	
	var _User = __webpack_require__(72);
	
	var _User2 = _interopRequireDefault(_User);
	
	var _LeftPictureBackground = __webpack_require__(20);
	
	var _LeftPictureBackground2 = _interopRequireDefault(_LeftPictureBackground);
	
	var _innovationWeb = __webpack_require__(91);
	
	var _innovationWeb2 = _interopRequireDefault(_innovationWeb);
	
	var _julien = __webpack_require__(92);
	
	var _julien2 = _interopRequireDefault(_julien);
	
	var _richard = __webpack_require__(95);
	
	var _richard2 = _interopRequireDefault(_richard);
	
	var _edlef = __webpack_require__(89);
	
	var _edlef2 = _interopRequireDefault(_edlef);
	
	var _vincent = __webpack_require__(96);
	
	var _vincent2 = _interopRequireDefault(_vincent);
	
	var _guy = __webpack_require__(90);
	
	var _guy2 = _interopRequireDefault(_guy);
	
	var _challenge = __webpack_require__(88);
	
	var _challenge2 = _interopRequireDefault(_challenge);
	
	var _MainPicture = __webpack_require__(21);
	
	var _MainPicture2 = _interopRequireDefault(_MainPicture);
	
	var _logoIntegralSystem = __webpack_require__(93);
	
	var _logoIntegralSystem2 = _interopRequireDefault(_logoIntegralSystem);
	
	var _polePixelVilleurbanneIntegralService = __webpack_require__(94);
	
	var _polePixelVilleurbanneIntegralService2 = _interopRequireDefault(_polePixelVilleurbanneIntegralService);
	
	var _AboutModule = __webpack_require__(78);
	
	var _AboutModule2 = _interopRequireDefault(_AboutModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var About = function (_Component) {
	  _inherits(About, _Component);
	
	  function About() {
	    _classCallCheck(this, About);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  About.prototype.render = function render() {
	    var smalltitle = "Qui somme nous ?";
	    var title = "Un Studio Web innovant";
	    var description = ["Integral Service est une agence Lyonnaise spécialisée dans les ", _react2.default.createElement(
	      "strong",
	      null,
	      "technologies de l'internet"
	    ), ". Notre coeur de métier est de réaliser des ", _react2.default.createElement(
	      "strong",
	      null,
	      "applications Web innovantes"
	    ), " pour répondre aux besoins métiers de nos clients.", _react2.default.createElement("br", null), _react2.default.createElement("br", null), "L'innovation est au coeur de notre savoir-faire. "];
	    var alt = "Integral Service et innovation";
	
	    var smalltitleAbout = "Ce qu'on adore ?";
	    var titleAbout = "Relever les défis";
	    var descriptionAbout = ["Depuis nos débuts, nous accompagnons nos clients qui nous proposent des ", _react2.default.createElement(
	      "strong",
	      null,
	      "d\xE9fis toujours plus grands \xE0 relever!"
	    ), _react2.default.createElement("br", null), _react2.default.createElement("br", null), " Nous avons pu travailler sur des complexités fonctionnelles importantes, des volumes de données démentiels, des quantités de visiteurs incroyables, des problématiques techniques complexes, des systèmes d'informations gigantesques... et on adore!"];
	    var altAbout = "Challenge Integral Service";
	
	    var industrie4 = ["Integral Service fait partie de la société ", _react2.default.createElement(
	      "a",
	      { href: "https://www.integral-system.fr", title: "Soci\xE9t\xE9 Integral System" },
	      "Integral System"
	    ), " créée en 2003, ", _react2.default.createElement(
	      "strong",
	      null,
	      "sp\xE9cialiste de l'informatique industrielle et l'automation"
	    ), ".", _react2.default.createElement("br", null), _react2.default.createElement("br", null), "Notre expertise de l'environnement industriel couplé à notre savoir-faire dans le milieu du Web est une combinaison gagnante dans le cadre de la mise en place d'environnements Web au sein des industries ainsi que dans le monde de l'IoT (Internet des Objets). ", _react2.default.createElement("br", null), _react2.default.createElement("br", null), "Nous vous accompnons dans ", _react2.default.createElement(
	      "strong",
	      null,
	      "l'entr\xE9e vers l'industrie 4.0."
	    )];
	    return _react2.default.createElement(
	      "div",
	      { className: _AboutModule2.default.aboutcontainer + " " },
	      _react2.default.createElement(_LeftPicture2.default, {
	        smalltitle: smalltitle,
	        title: title,
	        description: description,
	        picture: _innovationWeb2.default,
	        alt: alt
	      }),
	      _react2.default.createElement(
	        "div",
	        { className: "team row-bottom-padded-lg row-top-padded-lg" },
	        _react2.default.createElement(
	          "div",
	          { className: "container" },
	          _react2.default.createElement(
	            "h2",
	            { className: "text-center " + _AboutModule2.default.teamtitle + " " },
	            "Une \xE9quipe de passionn\xE9s"
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: " " + _AboutModule2.default.teamparagraph + " " },
	            "Notre exp\xE9rience cumul\xE9 dans le Web et le syst\xE8me d'information, nous permet d'appr\xE9hender les probl\xE9matiques m\xE9tiers de mani\xE8re efficace et novatrice. "
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "row " + _AboutModule2.default.teamcontainer + " " },
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-4 col-sm-6 col-xs-12" },
	              _react2.default.createElement(_User2.default, { name: "Edlef",
	                position: "Ninja du Web",
	                description: "Le processus de conception est bizarre et compliqu\xE9, car il implique des personnes, qui sont bizarres et compliqu\xE9es - Brad Frost",
	                picture: _edlef2.default,
	                alt: "Edlef - D\xE9veloppeur Web",
	                twitter: "https://twitter.com/edlef2" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-4 col-sm-6 col-xs-12" },
	              _react2.default.createElement(_User2.default, { name: "Julien",
	                position: "Web Yoda",
	                description: "Il semble que la perfection soit atteinte non quand il n'y a plus rien \xE0 ajouter, mais quand il n'y a plus rien \xE0 retrancher - Antoine de Saint-Exup\xE9ry",
	                picture: _julien2.default,
	                alt: "Julien Responsable technique Integral Service",
	                twitter: "https://twitter.com/jurv_dev" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-4 col-sm-6 col-xs-12" },
	              _react2.default.createElement(_User2.default, { name: "Richard",
	                position: "D\xE9veloppeur Full Stack",
	                description: " On dit qu\u2019on apprend avec ses erreurs, mais \xE0 mon avis c\u2019est une erreur\u2026 et si je me trompe au moins j\u2019aurais appris quelque chose ! ",
	                picture: _richard2.default,
	                alt: "Richard D\xE9veloppeur full stack",
	                twitter: "https://twitter.com/richard0r" })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "row " + _AboutModule2.default.devline2 },
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-4 col-sm-6 col-xs-12" },
	              _react2.default.createElement(_User2.default, { name: "Guy",
	                position: "D\xE9veloppeur Web",
	                description: "Il est beaucoup plus int\xE9ressant de discuter de la fa\xE7on de r\xE9soudre les probl\xE8mes plut\xF4t que de les signaler - Gibson",
	                picture: _guy2.default,
	                alt: "Guy D\xE9veloppeur Web",
	                twitter: "" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-4 col-sm-6 col-xs-12" },
	              _react2.default.createElement(_User2.default, { name: "Vincent",
	                position: "Chef de projet",
	                description: "La perception d\u2019un probl\xE8me peut changer \xE0 chaque fois que nous le regardons - Antichamber.com",
	                picture: _vincent2.default,
	                alt: "Vincent",
	                twitter: "https://twitter.com/smashou" })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(_LeftPictureBackground2.default, {
	        smalltitle: smalltitleAbout,
	        title: titleAbout,
	        description: descriptionAbout,
	        picture: _challenge2.default,
	        alt: altAbout
	      }),
	      _react2.default.createElement(_MainPicture2.default, { title: "Industrie et IoT",
	        description: industrie4,
	        picture: _logoIntegralSystem2.default,
	        alt: "Logo Integral System"
	      }),
	      _react2.default.createElement(
	        "div",
	        { className: "container row-bottom-padded-lg row-top-padded-lg" },
	        _react2.default.createElement(
	          "h2",
	          { className: "text-center" },
	          "Nous trouver"
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "row " + _AboutModule2.default.findus + " row" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-6" },
	            _react2.default.createElement("img", { src: _polePixelVilleurbanneIntegralService2.default, alt: "Photo du p\xF4le Pixel", className: "img-fluid" })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-6" },
	            _react2.default.createElement(
	              "p",
	              null,
	              "Nous sommes install\xE9s au sein du ",
	              _react2.default.createElement(
	                "a",
	                { href: "http://www.polepixel.fr/", title: "Site officiel du P\xF4le pixel", target: "_blank", rel: "nofollow" },
	                "P\xF4le Pixel"
	              ),
	              " \xE0 Villeurbanne qui, en plus de regrouper les studios de Cin\xE9ma Rh\xF4ne-Alpes, int\xE8gre des dizaines de soci\xE9t\xE9s sp\xE9cialis\xE9es dans le num\xE9rique !"
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: _AboutModule2.default.adressabout, itemscope: "", itemtype: "http://schema.org/Person" },
	              _react2.default.createElement(
	                "ul",
	                null,
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement("i", { className: "icon-phone" }),
	                  "\xA0",
	                  _react2.default.createElement(
	                    "a",
	                    { href: "tel:+33437697209", title: "Appeler Integral Service" },
	                    _react2.default.createElement(
	                      "span",
	                      { itemprop: "telephone" },
	                      "33 (0)4 37 69 72 09"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement("i", { className: "icon-fax" }),
	                  "\xA0",
	                  _react2.default.createElement(
	                    "span",
	                    { itemprop: "faxNumber" },
	                    "33 (0)4 72 33 88 45"
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement("i", { className: "icon-envelope" }),
	                  "\xA0",
	                  _react2.default.createElement(
	                    "span",
	                    { itemprop: "email" },
	                    "info(at)integral-service.fr"
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { className: _AboutModule2.default.details },
	                  _react2.default.createElement("i", { className: "icon-location2" }),
	                  "\xA0",
	                  _react2.default.createElement(
	                    "span",
	                    { itemprop: "name" },
	                    "INTEGRAL SERVICE"
	                  ),
	                  _react2.default.createElement("br", null),
	                  _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                      "span",
	                      { itemprop: "streetAddress" },
	                      "36 rue Emile Decorps",
	                      _react2.default.createElement("br", null),
	                      " Batiment 23",
	                      _react2.default.createElement("br", null)
	                    ),
	                    "  ",
	                    _react2.default.createElement(
	                      "span",
	                      { itemprop: "postalCode" },
	                      "69100"
	                    ),
	                    " ",
	                    _react2.default.createElement(
	                      "span",
	                      { itemprop: "addressLocality" },
	                      "VILLEURBANNE, France"
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "row find-us-map" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-12" },
	            _react2.default.createElement(
	              "div",
	              { className: "embed-responsive" },
	              _react2.default.createElement("iframe", { src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2783.696704183106!2d4.896692015780843!3d45.75722602186329!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47f4c1b3c098cb3d%3A0xd9e88d1ca910efc4!2sIntegral+Service!5e0!3m2!1sen!2sfr!4v1503069836873", width: "100%", height: "100%", frameborder: "0", allowfullscreen: true })
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return About;
	}(_react.Component);
	
	exports.default = About;
	module.exports = exports["default"];

/***/ }),

/***/ 78:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"aboutcontainer":"src-components-About----About-module---aboutcontainer---2T5AD","leftpicture":"src-components-About----About-module---leftpicture---PmYQY","leftpicturebackground":"src-components-About----About-module---leftpicturebackground---39dfL","fh5co-lead":"src-components-About----About-module---fh5co-lead---1TAS3","devline2":"src-components-About----About-module---devline2---1zUNm","teamparagraph":"src-components-About----About-module---teamparagraph---3HIK_","teamtitle":"src-components-About----About-module---teamtitle---2YhQQ","teamcontainer":"src-components-About----About-module---teamcontainer---1kV-h","fh5coperson":"src-components-About----About-module---fh5coperson---IggrC","bounce":"src-components-About----About-module---bounce---29Of_","row-bottom-padded-lg":"src-components-About----About-module---row-bottom-padded-lg---3haQQ","fh5colead":"src-components-About----About-module---fh5colead---28go0","findus":"src-components-About----About-module---findus---3Ig4f","adressabout":"src-components-About----About-module---adressabout---35jnO"};

/***/ }),

/***/ 175:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/about.8bf9bbab.jpg";

/***/ }),

/***/ 88:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/challenge.f15ffac1.png";

/***/ }),

/***/ 89:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/edlef.2a63e1c3.png";

/***/ }),

/***/ 90:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/guy.dacc0ffd.png";

/***/ }),

/***/ 91:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 92:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/julien.f2244b8f.png";

/***/ }),

/***/ 93:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 95:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/richard.26b4e9d5.png";

/***/ }),

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/vincent.9c8d6e32.png";

/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UserModule = __webpack_require__(81);
	
	var _UserModule2 = _interopRequireDefault(_UserModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var User = function (_React$Component) {
	    _inherits(User, _React$Component);
	
	    function User() {
	        _classCallCheck(this, User);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    User.prototype.render = function render() {
	        var _props = this.props,
	            name = _props.name,
	            position = _props.position,
	            description = _props.description,
	            picture = _props.picture,
	            alt = _props.alt,
	            twitter = _props.twitter;
	
	        return _react2.default.createElement(
	            "div",
	            { className: _UserModule2.default.fh5coperson },
	            _react2.default.createElement(
	                "figure",
	                { className: "animate-box" },
	                _react2.default.createElement("img", { src: picture, alt: alt, className: "img-fluid" })
	            ),
	            _react2.default.createElement(
	                "h3",
	                { className: " " + _UserModule2.default.fh5coname + " animate-box" },
	                name
	            ),
	            _react2.default.createElement(
	                "h4",
	                { className: " " + _UserModule2.default.fh5codesignation + " animate-box" },
	                position
	            ),
	            _react2.default.createElement(
	                "p",
	                { className: " " + _UserModule2.default.fh5cobio + " animate-box" },
	                description
	            ),
	            _react2.default.createElement(
	                "ul",
	                { className: _UserModule2.default.fh5cosocial },
	                _react2.default.createElement(
	                    "li",
	                    { className: "animate-box" },
	                    _react2.default.createElement(
	                        "a",
	                        { href: twitter, target: "_blank", rel: "nofollow", title: "Twitter de " + name },
	                        _react2.default.createElement("i", { className: "icon-twitter" })
	                    )
	                )
	            )
	        );
	    };
	
	    return User;
	}(_react2.default.Component);
	
	exports.default = User;
	module.exports = exports["default"];

/***/ }),

/***/ 81:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"fh5coperson":"src-components-Section----User-module---fh5coperson---3sDKZ","fh5coname":"src-components-Section----User-module---fh5coname---2k0R7","fh5codesignation":"src-components-Section----User-module---fh5codesignation---QIWYX","fh5cobio":"src-components-Section----User-module---fh5cobio---Q9nau"};

/***/ }),

/***/ 307:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(10);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _About = __webpack_require__(68);
	
	var _About2 = _interopRequireDefault(_About);
	
	var _SiteConfig = __webpack_require__(6);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	var _Header = __webpack_require__(12);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _SocialLinks = __webpack_require__(16);
	
	var _SocialLinks2 = _interopRequireDefault(_SocialLinks);
	
	var _SEO = __webpack_require__(14);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _HeaderPage = __webpack_require__(15);
	
	var _HeaderPage2 = _interopRequireDefault(_HeaderPage);
	
	var _Menu = __webpack_require__(13);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _Footer = __webpack_require__(11);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _ToTopButton = __webpack_require__(51);
	
	var _ToTopButton2 = _interopRequireDefault(_ToTopButton);
	
	var _about = __webpack_require__(175);
	
	var _about2 = _interopRequireDefault(_about);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AboutPage = function (_Component) {
	  _inherits(AboutPage, _Component);
	
	  function AboutPage() {
	    _classCallCheck(this, AboutPage);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  AboutPage.prototype.render = function render() {
	    var slug = this.props.pathContext.slug;
	
	    var postNode = {
	      "frontmatter": {
	        "title": "A propos d'Integral Service",
	        "description": "Integral Service est une agence Web Lyonnaise spécialisée dans les technologies de l'internet. Notre coeur de métier est de réaliser des applications Web innovantes pour répondre aux besoins métiers de nos clients.",
	        "cover": _about2.default
	      }
	    };
	
	    var title = "A propos d'Integral Service";
	    var description = "Nous vous accompagnons dans vos projets Web";
	    var goto = "En savoir plus";
	
	    return _react2.default.createElement(
	      "div",
	      { className: "about", id: "outer-container" },
	      _react2.default.createElement(_reactHelmet2.default, { title: title }),
	      _react2.default.createElement(_SEO2.default, { postPath: slug, postNode: postNode, postSEO: true }),
	      _react2.default.createElement(_Menu2.default, null),
	      _react2.default.createElement(
	        "div",
	        { id: "page-wrap" },
	        _react2.default.createElement(
	          "main",
	          { id: "fh5co-about" },
	          _react2.default.createElement(_Header2.default, null),
	          _react2.default.createElement(_HeaderPage2.default, { title: title, description: description, picture: _about2.default }),
	          _react2.default.createElement(_About2.default, null)
	        ),
	        _react2.default.createElement(_Footer2.default, null),
	        _react2.default.createElement(_ToTopButton2.default, null)
	      )
	    );
	  };
	
	  return AboutPage;
	}(_react.Component);
	
	exports.default = AboutPage;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-jsx-8407a46e747246134c9a.js